import React from 'react';
import moment from 'moment';

import { translate } from '../../../i18n/I18nProvider';
import CustomCheckbox from './CustomCheckbox';
import Optional from '../../../utils/optional';
import { checkIfAllSelected } from '../actions/mapActions';

const columns = ({
  selected,
  availableOptions,
  onSelectionChange,
  onAllSelectionChange
}) => {
  let elements = [
    {
      title: (
        <CustomCheckbox
          checked={checkIfAllSelected({ selected, availableOptions })}
          onChange={e => onAllSelectionChange(e)}
        />
      ),
      render: rowData => (
        <CustomCheckbox
          checked={Optional(selected.find(el => el.id === rowData.id))
            .map(el => el.selected)
            .or(false)}
          onChange={e => onSelectionChange(e, rowData.id)}
        />
      ),
      sorting: false,
      width: '50px'
    },
    {
      title: translate('NAME'),
      field: 'holiday'
    },
    {
      title: translate('SCHEDULES.NEXT_OCCURRENCE'),
      render: rowData => moment(rowData.next_occurrence).format('YYYY-MM-DD'),
      field: 'next_occurrence'
    },
    {
      title: translate('DATE'),
      field: 'shortDate'
    },
    {
      title: translate('TABLE.TYPE'),
      field: 'holiday_type'
    }
  ];

  return elements.map(el => {
    return {
      ...el,
      cellStyle: { padding: '0' },
      headerStyle: { padding: '0', fontSize: '13px' }
    };
  });
};

export default columns;
